export default __webpack_public_path__ + "static/media/productslide-1.6c29adcc.jpg";